export enum AchievementAccessibilityDescriptions {
    ClaimableAchievements = 'ClaimableAchievements',
    TokenCount = 'TokenCount',
    ActivePlantStatus = 'ActivePlantStatus',
    WaterStatus = 'WaterStatus',
    AchievementLevel = 'AchievementLevel'
}
